import React from 'react'
import './global.scss'
function GlobalFooter() {
  return (
    <div className='securedBtn'>
            <img style={{height:"10px"}} src='/images/lockKey.svg' alt='lock' />
            <div className='secured_content'>
                <p className='secured_p'>secured by</p>
                <img style={{height:"10px"}} src='/images/flickLogo.svg' alt='logo'/>
            </div>
    </div>
  )
}

export default GlobalFooter